import { render, staticRenderFns } from "./ModalFormAgregarCEUB.vue?vue&type=template&id=e53bfc60&scoped=true"
import script from "./ModalFormAgregarCEUB.vue?vue&type=script&lang=js"
export * from "./ModalFormAgregarCEUB.vue?vue&type=script&lang=js"
import style0 from "./ModalFormAgregarCEUB.vue?vue&type=style&index=0&id=e53bfc60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e53bfc60",
  null
  
)

export default component.exports